<template>
  <div class="home home-bg home-bg-2">
    <Starfield />
    <div class="shooting-sky" aria-hidden="true">
      <i class="shooting-star ss1"></i>
      <i class="shooting-star ss2"></i>
    </div>
    <div class="text-center pt-1 home-content">
      <h2 class="display-5 mt-5 mb-3 heading">CVPA PRESENTS...</h2>
      <!-- 2026 theme: "Last Dance" designed logo art (teal/white on transparent). -->
      <img
        src="../assets/img/last-dance-logo.png"
        alt="CVPA Seniors - Last Dance! - Class of 2026"
        class="hero-logo img-fluid my-1"
      />
      <h2 class="pb-5">
        <div class="my-1">
          <div class="mb-2">Sunday, June 7, 2026</div>

          <div class="mb-1">SHOWTIME: 6:00 PM</div>
          <div class="mb-5 text-sm">
            House opens 30 minutes before showtime.
          </div>

          <div class="mb-1">Douglas Morrisson Theatre</div>
          <div class="mb-5 text-md">22311 N. 3rd Street, Hayward, CA 94546</div>

          <div class="mb-5">
            <router-link
              class="btn btn-danger btn-lg rounded-0"
              to="/schedule?r=2"
              >Program</router-link
            >
          </div>
        </div>
      </h2>
    </div>
  </div>
</template>

<script>
import Starfield from "../components/Starfield";

export default {
  name: "Home",
  components: { Starfield },
  data() {
    return {
      maxIndex: 2,
      index: 1,
    };
  },
  methods: {},
};
</script>
